export var featureFlags = {
    'proctoring_logs': false,
    'new_online_test_list': false
};

export function initOptimizelyClient() {
    const optimizelySDK = require('@optimizely/optimizely-sdk');
    optimizelySDK.setLogLevel('error');
    const optimizelyClientInstance  = optimizelySDK.createInstance({
        sdkKey: process.env.VUE_APP_OPTIMIZELY_SDK_KEY
    });
    optimizelyClientInstance.onReady().then(() => {
        for (const [key, ] of Object.entries(featureFlags)) {
            featureFlags[key] = optimizelyClientInstance.isFeatureEnabled(key, '');
        }
        optimizelyClientReady();
    });
}

let callbacks = [];
let clientReady = false;

function optimizelyClientReady(){
    clientReady = true;
    callbacks.forEach((callback) => {callback()});
}

export function onClientReady(fn){
    if (clientReady) {
       fn();
    } else {
        callbacks.push(fn);
    }
}
